"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toast = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarCore = require("@smartsheet/lodestar-core");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireWildcard(require("react"));
var _ToastIconContainer = require("../styled/ToastIconContainer");
var _ToastStyled = require("../styled/ToastStyled");
var _toastTheme = require("../styled/toastTheme");
var _ToastContext = require("./ToastContext");
const presets = {
  error: /*#__PURE__*/_react.default.createElement(_ursaIcons.AlertErrorFilledIcon, {
    size: 24,
    color: "currentColor"
  }),
  success: /*#__PURE__*/_react.default.createElement(_ursaIcons.SuccessFilledIcon, {
    size: 24,
    color: "currentColor"
  }),
  warning: /*#__PURE__*/_react.default.createElement(_ursaIcons.WarningFilledIcon, {
    size: 24,
    color: "currentColor"
  }),
  info: /*#__PURE__*/_react.default.createElement(_ursaIcons.InfoFilledIcon, {
    size: 24,
    color: "currentColor"
  })
};
const getIcon = (type, icon) => {
  if (icon === null) {
    return null;
  } else {
    return icon || presets[type];
  }
};
const Toast = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    type,
    icon,
    clientId,
    ...rest
  } = _ref;
  const {
    key
  } = (0, _lodestarCore.useTheme)();
  const themeMode = key;
  const resolvedIcon = getIcon(type, icon);
  const memoizedToastContextValue = (0, _react.useMemo)(() => ({
    type
  }), [type]);
  return /*#__PURE__*/_react.default.createElement(_ToastContext.ToastContextProvider, {
    value: memoizedToastContextValue
  }, /*#__PURE__*/_react.default.createElement(_ToastStyled.ToastStyled, (0, _extends2.default)({
    themeMode: themeMode,
    type: type,
    "data-client-id": clientId,
    ref: ref
  }, rest), resolvedIcon && /*#__PURE__*/_react.default.createElement(_ToastIconContainer.ToastIconContainer, {
    "aria-hidden": true,
    iconColor: _toastTheme.toastTheme.iconColor[type](themeMode)
  }, resolvedIcon), children));
});
exports.Toast = Toast;
Toast.displayName = "Toast";
//# sourceMappingURL=Toast.js.map